import { IconButton, Tooltip } from '@material-ui/core';
import { Copy as IconCopy } from 'lucide-react';
import React from 'react';
import { withStoppedPropagation } from '../../helpers';
import { useSnackbar } from '../../hooks/useSnackbar';
import { useUnsafeTranslation } from '../../i18next';

type Props = {
  text?: string;
  tooltip?: string;
  successMessage?: string;
  size?: 'normal' | 'small';
};

export const CopyButton = ({
  text = '',
  tooltip,
  successMessage,
  size
}: Props) => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useUnsafeTranslation();
  const tooltipText = tooltip || `${t('Copy to clipboard')}`;
  const snackText = successMessage || t('Link copied!');
  return (
    <Tooltip title={tooltipText}>
      <IconButton
        onClick={withStoppedPropagation(() => {
          navigator.clipboard.writeText(text);
          enqueueSnackbar(snackText, { variant: 'info' });
        })}
      >
        <IconCopy size={size === 'small' ? 12 : 16} />
      </IconButton>
    </Tooltip>
  );
};
